module.exports = __webpack_public_path__ + "01c234a7a162bdd44e3af892911bf3e7.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ic_calender.svg
// module id = QsbM
// module chunks = 5